import { DocumentNode } from 'graphql';
import { gql } from '@apollo/client';
import { reduce, map } from 'ramda';

export const combineMemberFragments = (
	names: string[] = [],
	nodes: DocumentNode[] = [],
	queryName = ''
) => {
	const fragments = reduce(
		(acc: string | DocumentNode, node) => {
			return gql`
				${acc}
				${node}
			`;
		},
		'',
		nodes
	);

	const reducerQuery = gql`
		${fragments}
		query ${queryName} {
			authenticatedMember {
				${map(
					(name) =>
						`...${name}
						`,
					names
				)}
			}
		}
	`;

	return reducerQuery;
};

export const combineQueryFragments = (
	names: string[] = [],
	nodes: DocumentNode[] = [],
	queryName = ''
) => {
	const fragments = reduce(
		(acc: string | DocumentNode, node) => {
			return gql`
				${acc}
				${node}
			`;
		},
		'',
		nodes
	);

	const reducerQuery = gql`
		${fragments}
		query ${queryName} {
			${map(
				(name) =>
					`...${name}
					`,
				names
			)}
		}
	`;

	return reducerQuery;
};
